module.exports = __webpack_public_path__ + "static/media/person.c8465fe3.svg";